import React, { useContext, useEffect, useState } from "react";
import Pagereview from "../../components/pageReview/Pagereview";
import { PaginationRenderer } from "../CMSRenderer/components";
import { getCircular, getCircularDetails } from "../../utils/apiCalls";
import moment from "moment";
import { FormContext } from "../CMSRenderer/CMSRenderer";
import "moment/locale/ar";

const Circulars = ({ config }) => {
  const { currentLang } = useContext(FormContext);
  const [showModal, setShowModal] = useState(false);
  const [circularDetails, setCircularDetails] = useState(null);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    currentPage: 1,
    totalPage: 1,
    totalItems: 1,
  });

  const [circularData, setCircularData] = useState([]);

  const [filteredCirculars, setFilteredCirculars] = useState([]);

  useEffect(() => {
    getCircular({
      page: pagination?.currentPage || 1,
      pageSize: pagination?.pageSize || 10,
      language: currentLang,
    }).then((res) => {
      setPagination({
        ...pagination,
        pageSize: res?.Data?.pageSize || 10,
        totalPage: res?.Data?.totalPages || 1,
        totalItems: res?.Data?.totalItems || 1,
      });
      setFilteredCirculars(res?.Data.data || []);
    });
  }, [pagination?.currentPage]);

  useEffect(() => {
    if (!!filteredCirculars) {
      setCircularData([...filteredCirculars]);
    }
  }, [filteredCirculars]);

  const getSizeLabel = (mb) => {
    const bytes = mb * 1024 * 1024;
    if (bytes >= 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    } else {
      return `${(bytes / 1024).toFixed(2)} KB`;
    }
  };

  const searchCirculars = (searchKey) => {
    console.log("searched", searchKey);
    setCircularData(
      filteredCirculars.filter((each) => {
        return each.header.toLowerCase().includes(searchKey.toLowerCase()) || each.circularRefNum.toLowerCase().includes(searchKey.toLowerCase());
      }) || [],
    );
  };

  const openCircular = async (ref) => {
    setCircularDetails(null);
    setShowModal(true);
    const circularfetch = await getCircularDetails({
      ref: ref,
      language: currentLang,
    });

    if (!!circularfetch && circularfetch.Status == 200) {
      setCircularDetails(circularfetch.Data || null);
    }
  };

  return (
    <>
      {/* <dda-breadcrumb
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs='[{"text":"Home","icon":"home","url":"/"},{"text":"Circulars","icon":"menu_book","url":"/policiesRegulationsAndCirculars/circulars"}]'
      ></dda-breadcrumb> */}
      <h2 className="my-4 Medium text-primary">
        {currentLang === "en" ? config.title : config.title_ar}
      </h2>

      <dda-search-input
        placeholder={
          currentLang === "en"
            ? config.search_input_placeholder
            : config.search_input_placeholder_ar
        }
        label={
          currentLang === "en"
            ? config.search_input_label
            : config.search_input_label_ar
        }
        size="default"
        helper_text=""
        error_message=""
        validation_id=""
        show_button="true"
        has_error="false"
        custom_class="md:!my-4 my-2"
        component_mode=""
        button_id="button"
        input_id="Search"
        aria_label="search-input"
        button_aria_label="clear-search"
        onbuttonClicked={(event) => {
          console.log({ event });
          const searchedText = event.detail || "";
          searchCirculars(searchedText);
        }}
        search_input_name="search-input"
        close_button_name="close-button"
        search_button_name="search-button"
        button_text={
          currentLang === "en"
            ? config.search_button_text
            : config.search_button_text_ar
        }
      ></dda-search-input>

      <div class="dda-table-container">
        <div className="overflow-x-auto">
          <table class="dda-table w-full min-w-[650px]">
            <thead>
              <tr className="*:!font-semibold ">
                <th>
                  {currentLang === "en"
                    ? config.table_header
                    : config.table_header_ar}
                </th>
                <th>
                  {currentLang === "en"
                    ? config.table_header_1
                    : config.table_header_1_ar}
                </th>
                <th>
                  {currentLang === "en"
                    ? config.table_header_2
                    : config.table_header_2_ar}
                </th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {circularData?.map((circular) => {
                return (
                  <tr>
                    <td>
                      <p>{circular?.circularRefNum || ""}</p>
                    </td>
                    <td>
                      <p>{circular?.header || ""}</p>
                    </td>
                    <td>
                      <p>
                        {moment(new Date(circular?.publishedDate))
                          .locale(currentLang === "en" ? "en" : "ar")
                          .format("dddd, MMMM DD, YYYY")
                          .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
                          .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) ||
                          ""}
                      </p>
                    </td>
                    <td>
                      <dda-button
                        button_color="default-tertiary"
                        start_icon=""
                        button_text={
                          currentLang === "en"
                            ? config.view_documents
                            : config.view_documents_ar
                        }
                        end_icon=""
                        custom_class=""
                        component_mode=""
                        button_id="button"
                        aria_label="button"
                        onclick={() => {
                          openCircular(circular.circularRefNum);
                        }}
                        button_name="button"
                        class="hydrated"
                      ></dda-button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div class="dda-table-footer">
          <div class="pagination w-full">
            <PaginationRenderer
              totalPage={pagination?.totalPage}
              currentPage={pagination?.currentPage}
              pageSize={pagination?.pageSize}
              totalItems={pagination?.totalItems}
              currentLang={currentLang}
              handlePage={(e) =>
                setPagination({
                  ...pagination,
                  currentPage: e,
                })
              }
            />
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setShowModal(false)}
          />

          {/* Modal */}
          <div className="relative bg-white rounded-lg shadow-xl w-full max-w-4xl p-6 mx-4">
            {circularDetails == null && (
              <div className="w-full flex align-items-center justify-center p-4">
                <div className="w-8 h-8 border-2 border-gray-300 border-t-teal-600 rounded-full animate-spin"></div>
              </div>
            )}
            {!!circularDetails && (
              <div className="max-h-[60vh] overflow-auto">
                <h2 className="font-semibold mb-4 text-primary">
                  {circularDetails.header}
                </h2>
                <p className="mb-3 font-semibold text-gray-600">
                  <span className="text-primary">
                    {moment(new Date(circularDetails?.publishedDate)).format(
                      "DD MMM, YYYY",
                    )}
                  </span>
                  {" | "}
                  {circularDetails.subTitle}
                </p>

                <div
                  className="mb-6"
                  dangerouslySetInnerHTML={{ __html: circularDetails.content }}
                ></div>

                {!!circularDetails.documentDetails && (
                  <div className="flex flex-wrap mt-2">
                    <div className="h-[1px] w-full border border-default rounded-base shadow-xs mb-4 mr-tooltip"></div>
                    <p className="text-primary font-bold mb-4">
                      {currentLang == "en" ? "Attachments" : "المرفقات"}
                    </p>
                    {circularDetails.documentDetails.map((eDoc) => {
                      return (
                        <div className="bg-neutral-primary-soft block p-6 border border-default rounded-base shadow-xs mb-4 rounded-xl mr-tooltip w-full">
                          <a
                            className="flex justify-between items-center mr-tooltip"
                            href={`/api/hasana/downloadfile/` + eDoc.vsId}
                            target="_blank"
                          >
                            <div className="flex items-center gap-4 mr-tooltip">
                              <img
                                alt="File Type Icon"
                                src="/ui-engine/static/media/File_Type.0f14815e59cb7e7377688ab28db10eb2.svg"
                                className="mr-tooltip"
                              />
                              <div className="mr-tooltip">
                                <p className="body text-black mr-tooltip">
                                  {eDoc.documentLabel || "Attachment"}
                                </p>
                              </div>
                            </div>
                            <img
                              alt="Download Icon"
                              className="cursor-pointer mr-tooltip"
                              src="/ui-engine/static/media/file_download.bff6f3cf7d7712b13ad33e3b21ecf303.svg"
                            />
                          </a>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            <hr className="mb-3" />
            <div className="flex justify-end">
              <dda-button
                button_color="default-tertiary"
                start_icon=""
                button_text={currentLang === "en" ? "Close" : "أغلق"}
                end_icon=""
                custom_class=""
                component_mode=""
                button_id="button"
                aria_label="button"
                onclick={() => {
                  setShowModal(false);
                }}
                button_name="button"
                class="hydrated"
              ></dda-button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Circulars;
